import { useEffect, useState } from 'react';

export const GITHUB_REPO = 'mekenthompson/calendar-app';
export const GITHUB_REPO_URL = `https://github.com/${GITHUB_REPO}`;

/**
 * Fetch the live GitHub star count for the project repo, client-side.
 *
 * Returns null until loaded, and stays null on any failure (rate limit,
 * offline, etc.) so callers can gracefully omit the count.
 */
export function useGithubStars(): number | null {
  const [stars, setStars] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`https://api.github.com/repos/${GITHUB_REPO}`, {
      headers: { Accept: 'application/vnd.github+json' },
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { stargazers_count?: number } | null) => {
        if (!cancelled && data && typeof data.stargazers_count === 'number') {
          setStars(data.stargazers_count);
        }
      })
      .catch(() => {
        // Graceful fallback: no star count shown.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return stars;
}
